import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { motion } from 'framer-motion';

/**
 * Composant réutilisable pour afficher un état de chargement avec animations stabilisées
 */
const LoadingState = ({ 
  message = "Chargement...", 
  minHeight = 200,
  size = "medium",
  ariaLabel,
  announce = true
}) => {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 56
  };

  // Animations simplifiées et plus stables
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      role="status"
      aria-label={ariaLabel || message}
      aria-live={announce ? "polite" : "off"}
      aria-busy="true"
      style={{ transform: 'translate3d(0,0,0)' }} // Force GPU acceleration
    >
      <Box 
        display="flex" 
        flexDirection="column"
        justifyContent="center" 
        alignItems="center" 
        minHeight={minHeight}
        sx={{ p: 3 }}
      >
        <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
          <CircularProgress 
            color="primary" 
            size={sizeMap[size]} 
            thickness={4}
            aria-hidden="true"
            sx={{ 
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round',
              }
            }}
          />
        </Box>
        
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'text.secondary',
            textAlign: 'center',
            fontWeight: 500,
            letterSpacing: '0.5px'
          }}
        >
          {message}
        </Typography>
      </Box>
    </motion.div>
  );
};

export default LoadingState;
